import React, {useState} from "react";
import {
    SearchBar,
    StyledFooterDiv,
    StyledFooterText, StyledIcon,
    StyledTable,
    StyledTd,
    StyledTh,
    StyledTr,
    TableBody,
    TableFooter,
    TableHead
} from "./DataTable.styles";
import {formatDate} from "../../../helpers/helpersFunctions";
import SubsectionText from "../../section-items/SubsectionText/SubsectionText";
import PropTypes from 'prop-types';
import {rounds} from "../../forms/ManageDataForm";
import {faTrashAlt} from "@fortawesome/free-solid-svg-icons";
import {deleteData} from "../../../helpers/fetchData";

const DataTable = ({data, dataType, adminTable, sendDataToParent}) => {

    const [search, setSearch] = useState('');

    const text = {
        tournaments: {
            counter: 'Liczba rozegranych turniejów: ',
            search: 'Wprowadź nazwę turnieju, który chcesz wyszukać.',
            search_placeholder: 'Nazwa turnieju...'
        },
        posts: {
            counter: 'Liczba postów: ',
            search: 'Wprowadź tytuł postu, który chcesz wyszukać.',
            search_placeholder: 'Tytuł postu...'
        },
        players: {
            counter: 'Liczba zawodników: ',
            search: 'Wprowadź nazwisko zawodnika, którego chcesz wyszukać.',
            search_placeholder: 'Nazwisko zawodnika...'
        },
        matches: {
            counter: 'Liczba meczy: ',
            search: 'Wprowadź datę meczu, który chcesz wyszukać.',
            search_placeholder: 'Data odbycia się spotkania...'
        }
    }

    const deleteItem = (type, id) => {
        deleteData(type, id)
            .then((res) => res.status === 204 ? sendDataToParent(true) : sendDataToParent(false))
            .catch((e) => sendDataToParent(false));
    }

    const renderHeaders = () => {
        switch (dataType) {
            case 'posts':
                return (
                    <StyledTr>
                        <StyledTh>{'Lp.'}</StyledTh>
                        {adminTable && <StyledTh>{'Identyfikator'}</StyledTh>}
                        <StyledTh>{'Obrazki'}</StyledTh>
                        <StyledTh>{'Tytuł'}</StyledTh>
                        <StyledTh>{'Treść'}</StyledTh>
                        <StyledTh>{'Data'}</StyledTh>
                        {adminTable && <StyledTh>{'Akcja'}</StyledTh>}
                    </StyledTr>
                );
            case 'players':
                return (
                    <StyledTr>
                        <StyledTh>{'Lp.'}</StyledTh>
                        {adminTable && <StyledTh>{'Identyfikator'}</StyledTh>}
                        <StyledTh>{'Imię'}</StyledTh>
                        <StyledTh>{'Nazwisko'}</StyledTh>
                        <StyledTh>{'Data urodzenia'}</StyledTh>
                        <StyledTh>{'Pozycja'}</StyledTh>
                        <StyledTh>{'Kraj'}</StyledTh>
                        <StyledTh>{'Liczba goli'}</StyledTh>
                        <StyledTh>{'Liczba meczy'}</StyledTh>
                        {adminTable && <StyledTh>{'Akcja'}</StyledTh>}
                    </StyledTr>
                );
            case 'matches':
                return (
                    <StyledTr>
                        <StyledTh>{'Lp.'}</StyledTh>
                        {adminTable && <StyledTh>{'Identyfikator'}</StyledTh>}
                        <StyledTh>{'Drużyna przeciwna'}</StyledTh>
                        <StyledTh>{'Turniej'}</StyledTh>
                        <StyledTh>{'Skład'}</StyledTh>
                        <StyledTh>{'Data spotkania'}</StyledTh>
                        <StyledTh>{'Gole (D)'}</StyledTh>
                        <StyledTh>{'Gole (P)'}</StyledTh>
                        <StyledTh>{'Wynik'}</StyledTh>
                        <StyledTh>{'Runda'}</StyledTh>
                        <StyledTh>{'Komentarz'}</StyledTh>
                        {adminTable && <StyledTh>{'Akcja'}</StyledTh>}
                    </StyledTr>
                );
            case 'tournaments':
                return (
                    <StyledTr>
                        <StyledTh>{'Lp.'}</StyledTh>
                        {adminTable && <StyledTh>{'Identyfikator'}</StyledTh>}
                        <StyledTh>{'Zajęta pozycja'}</StyledTh>
                        <StyledTh>{'Nazwa turnieju'}</StyledTh>
                        <StyledTh>{'Lokalizacja'}</StyledTh>
                        <StyledTh>{'Data rozpoczęcia'}</StyledTh>
                        <StyledTh>{'Data zakończenia'}</StyledTh>
                        {adminTable && <StyledTh>{'Akcja'}</StyledTh>}
                    </StyledTr>
                );
            default:
                return (<StyledTr/>);
        }
    };

    const renderCells = () => {

        switch (dataType) {
            case 'posts':
                return data.filter(e => e.title ? e.title.toLowerCase().includes(search.toLowerCase()) : e).map((e, index) =>
                    <StyledTr key={e.id}>
                        <StyledTd>{index + 1 + '.'}</StyledTd>
                        {adminTable && <StyledTd>{e.id}</StyledTd>}
                        <StyledTd>{e.images ? e.images.length : 0}</StyledTd>
                        <StyledTd>{e.title}</StyledTd>
                        <StyledTd>{decodeURI(e.text).length}</StyledTd>
                        <StyledTd>{formatDate(e.date)}</StyledTd>
                        {adminTable && <StyledTd>
                            <StyledIcon onClick={() => deleteItem('posts', e.id)} icon={faTrashAlt}/>
                        </StyledTd>}
                    </StyledTr>);
            case 'players':
                return data.filter(e => e.surname ? e.surname.toLowerCase().includes(search.toLowerCase()) : e).map((e, index) =>
                    <StyledTr key={e.id}>
                        <StyledTd>{index + 1 + '.'}</StyledTd>
                        {adminTable && <StyledTd>{e.id}</StyledTd>}
                        <StyledTd>{e.name}</StyledTd>
                        <StyledTd>{e.surname}</StyledTd>
                        <StyledTd>{e.date_of_birth ? formatDate(e.date_of_birth, 'short') : '-'}</StyledTd>
                        <StyledTd>{e.position}</StyledTd>
                        <StyledTd>{e.country}</StyledTd>
                        <StyledTd>{e.number_of_goals}</StyledTd>
                        <StyledTd>{e.number_of_matches}</StyledTd>
                        {adminTable && <StyledTd>
                            <StyledIcon onClick={() => deleteItem('players', e.id)} icon={faTrashAlt}/>
                        </StyledTd>}
                    </StyledTr>);
            case 'matches':
                return data.filter(e => e.date ? formatDate(e.date, 'short').includes(search) : e).map((e, index) =>
                    <StyledTr key={e.id}>
                        <StyledTd>{index + 1 + '.'}</StyledTd>
                        {adminTable && <StyledTd>{e.id}</StyledTd>}
                        <StyledTd>{e.enemy_name}</StyledTd>
                        <StyledTd>{e.tournament_info ? e.tournament_info.name : '-'}</StyledTd>
                        <StyledTd>{e.goals_info ? e.goals_info.length : '-'}</StyledTd>
                        <StyledTd>{formatDate(e.date, 'short')}</StyledTd>
                        <StyledTd>{e.club_goals}</StyledTd>
                        <StyledTd>{e.enemy_goals}</StyledTd>
                        <StyledTd>{e.result === 'w' ? 'W' : e.result === 'l' ? 'P' : 'R'}</StyledTd>
                        <StyledTd>{rounds[e.round]}</StyledTd>
                        <StyledTd>{e.comment ?? '-'}</StyledTd>
                        {adminTable && <StyledTd>
                            <StyledIcon onClick={() => deleteItem('matches', e.id)} icon={faTrashAlt}/>
                        </StyledTd>}
                    </StyledTr>);
            case 'tournaments':
                return data.filter(e => e.name ? e.name.toLowerCase().includes(search.toLowerCase()) : e).map((e, index) =>
                    <StyledTr key={e.id}>
                        <StyledTd adminTable={adminTable}>{index + 1 + '.'}</StyledTd>
                        {adminTable && <StyledTd adminTable={adminTable}>{e.id}</StyledTd>}
                        <StyledTd adminTable={adminTable}>{e.place}</StyledTd>
                        <StyledTd adminTable={adminTable}>{e.name}</StyledTd>
                        <StyledTd adminTable={adminTable}>{e.venue ?? '-'}</StyledTd>
                        <StyledTd adminTable={adminTable}>{e.start_date ? formatDate(e.start_date, 'short') : '-'}</StyledTd>
                        <StyledTd adminTable={adminTable}>{e.end_date ? formatDate(e.end_date, 'short') : '-'}</StyledTd>
                        {adminTable && <StyledTd>
                            <StyledIcon onClick={() => deleteItem('tournaments', e.id)} icon={faTrashAlt}/>
                        </StyledTd>}
                    </StyledTr>);
            default:
                return (<StyledTr/>);
        }
    };

    return (
        <>
            <StyledTable>
                <TableHead>
                    {
                        renderHeaders()
                    }
                </TableHead>
                <TableBody>
                    {
                        renderCells()
                    }
                </TableBody>
                <TableFooter>
                    <StyledTr>
                        <StyledTd>
                            <StyledFooterDiv>{text[dataType].counter}<StyledFooterText>{data.length}</StyledFooterText></StyledFooterDiv>
                        </StyledTd>
                    </StyledTr>
                </TableFooter>
            </StyledTable>
            <SubsectionText>{text[dataType].search}</SubsectionText>
            <SearchBar value={search} onChange={(e) => setSearch(e.target.value)}
                       placeholder={text[dataType].search_placeholder}/>
        </>
    );
};

DataTable.propTypes = {
    data: PropTypes.array.isRequired,
    dataType: PropTypes.string.isRequired,
    adminTable: PropTypes.bool
}

DataTable.defaultProps = {
    adminTable: false
}

export default DataTable;
